<template>
  <div class="contact-us" id="contact">
    <h2 class="contact-us__title">Comencemos</h2>
    <form class="contact-us__form" @submit.prevent="submitForm">
      <div class="contact-us__form-group">
        <label for="name">Nombre:</label>
        <input type="text" id="name" v-model="formData.name" required />
      </div>
      <div class="contact-us__form-group">
        <label for="email">Email:</label>
        <input type="email" id="email" v-model="formData.email" required />
      </div>
      <div class="contact-us__form-group">
        <label for="message">Mensaje:</label>
        <textarea id="message" v-model="formData.message" required></textarea>
      </div>

      <div
        v-if="formStatus === 'success'"
        class="contact-us__status-message success"
      >
        Formulario enviado exitosamente.
      </div>
      <div
        v-if="formStatus === 'error'"
        class="contact-us__status-message error"
      >
        Ocurrió un error al enviar el formulario.
      </div>

      <button type="submit" class="contact-us__submit-btn">Enviar</button>
    </form>

    <div class="contact-us__social-links">
      <a
        href="mailto:datacraft.studios@gmail.com"
        class="contact-us__social-link"
        ><img src="@/assets/icon/gmail.svg" alt="email" loading="lazy"/></a>
      <a
        href="https://www.linkedin.com/in/perezcatriel"
        class="contact-us__social-link"
        target="_blank"
        ><img src="@/assets/icon/linkedin.svg" alt="linkedin" loading="lazy"/></a>
      <a
        href="https://instagram.com/datacraft_studios?utm_source=qr&igshid=NGExMmI2YTkyZg%3D%3D"
        class="contact-us__social-link"
        target="_blank"
        ><img src="@/assets/icon/instagram.svg" alt="instagram" loading="lazy"/></a>
    </div>

    <div class="contact-us__created">
      <a href="#"><img src="../assets/logo.svg" alt="DataCraft" loading="lazy"/></a>
      <p class="contenedor"><router-link to="/politica-privacidad" class="politica-privacidad" >Política de Privacidad & Términos de Servicios</router-link></p>
      <div>
        <p>© By <span>DataCraft</span></p>
      </div>
    </div>
  </div>
</template>

<script>
import emailjs from "emailjs-com";

export default {
  name: "CxContactUs",
  data() {
    return {
      formData: {
        name: "",
        email: "",
        message: "",
      },
      formStatus: null, // Nuevo estado para manejar el resultado del envío del formulario
    };
  },
  methods: {
    submitForm() {
      emailjs
        .send(
          "service_d8y9b5k",
          "template_3oukynk",
          {
            from_name: this.formData.name,
            from_email: this.formData.email,
            message: this.formData.message,
          },
          "j0V82kbYqUIR3StVz"
        )
        .then((response) => {
          console.log("Correo electrónico enviado con éxito:", response);
          // Restablecer el formulario después del envío exitoso
          this.formData = {
            name: "",
            email: "",
            message: "",
          };
          this.formStatus = "success"; // Actualiza el estado a éxito
          setTimeout(this.hideMessage, 2000);
        })
        .catch((error) => {
          console.error("Error al enviar el correo electrónico:", error);
          this.formStatus = "error"; // Actualiza el estado a error
          setTimeout(this.hideMessage, 2000);
        });
    },
    hideMessage() {
      this.formStatus = null; // Reinicia el estado del mensaje después de 2 segundos
    },
  },
};
</script>

<style scoped>
.contact-us {
  color: var(--color-accent);
  max-width: 600px;
  margin: 20px auto;
  font-family: var(--font-sans);
  font-size: 1rem;
  width: 90vw;
}

.contact-us__title {
  font-family: var(--font-sans);
  color: var(--color-primary);
  font-size: 2rem;
  font-weight: bold;
  margin: 20px auto;
}

.contact-us__form {
  display: flex;
  flex-direction: column;
}

.contact-us__form-group {
  margin-bottom: 15px;
}

.contact-us__form-group label {
  font-weight: bold;
  font-size: 1rem;
}

.contact-us__form-group input,
.contact-us__form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid var(--color-accent);
  background-color: var(--color-background);
  color: var(--color-primary);
  font-family: var(--font-sans);
  font-size: 1rem;
  border-radius: 5px;
}

.contact-us__form-group textarea {
  height: 15vh;
}

.contact-us__form-group input:focus,
.contact-us__form-group textarea:focus {
  color: var(--color-text);
  background-color: var(--color-accent);
  outline-color: var(--color-accent);
}

.contact-us__submit-btn {
  background-color: var(--color-accent);
  color: var(--color-background);
  font-family: var(--font-sans);
  font-size: 1rem;
  font-weight: bold;
  margin: auto;
  padding: 10px;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  width: 100%;
}

.contact-us__submit-btn:hover {
  background-color: var(--color-primary);
}

.contact-us__social-links {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.contact-us__social-link {
  margin: 0 10px;
  color: var(--color-text);
  text-decoration: none;
  font-size: 1.5rem;
}

.contact-us__social-link img {
  width: 32px;
}

.contact-us__created {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.8rem;
  margin-top: 20px;
  padding: 10px 0;
}

.contact-us__created img {
  width: 40px;
  margin-bottom: 10px;
}

.contact-us__created span {
  font-size: 1rem;
}

.contact-us__status-message {
  margin: 10px 0;
  padding: 10px;
  border-radius: 5px;
  font-weight: bold;
}

.success {
  background-color: #8bc34a;
  /* Color de fondo verde para éxito */
  color: var(--color-background);
}

.error {
  background-color: #f44336;
  /* Color de fondo rojo para error */
  color: var(--color-text);
}

.politica-privacidad {
  color: var(--color-accent);
  font-family: var(--font-sans);
  font-size: 0.8rem;
  font-weight: bold;
  text-decoration: none;
  text-align: center;
}

@media (min-width: 768px) {
  .contact-us {
    width: 70vw;
  }

  .contact-us__title {
    font-size: 2.5rem;
  }

  .contact-us__form-group label {
    font-size: 1.2rem;
  }

  .contact-us__form-group input,
  .contact-us__form-group textarea {
    font-size: 1.2rem;
  }
}

@media (min-width: 1024px) {
  .contact-us {
    width: 50vw;
  }

  .contact-us__title {
    font-size: 3rem;
  }

  .contact-us__form-group label {
    font-size: 1.4rem;
  }

  .contact-us__form-group input,
  .contact-us__form-group textarea {
    font-size: 1.4rem;
  }

  .contact-us__created {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .politica-privacidad {
    font-size: 1rem;
  }
}
</style>
